const faqs = [
  {
    q: '虫虫漫画和汗汗虫虫漫画是什么关系？',
    a: '虫虫漫画是汗汗虫虫漫画的正式名称，汗汗漫画、虫虫汗汗等均为平台早期使用的别名。老用户通过这些记忆点同样可以找到我们，平台内容和服务完全一致。',
  },
  {
    q: '虫虫漫画收费吗？需要注册账号吗？',
    a: '虫虫漫画所有漫画内容完全免费，无需注册或登录即可在线阅读。我们致力于为漫画爱好者提供无障碍的阅读体验，韩漫日漫国漫全集均可免费畅读。',
  },
  {
    q: '支持哪些类型的漫画？更新频率如何？',
    a: '平台涵盖韩漫、日漫、国漫三大品类，包括恋爱、悬疑、热血、玄幻、都市等多种题材。每日稳定更新，热门连载作品保持同步更新节奏，让读者第一时间看到最新章节。',
  },
  {
    q: '阅读体验怎么样？支持什么设备？',
    a: '虫虫漫画采用下拉式阅读模式，无需翻页即可连续阅读，体验流畅自然。平台完美适配手机、平板和电脑端，随时随地打开浏览器就能看，无需下载App。',
  },
  {
    q: '遇到漫画加载慢或打不开怎么办？',
    a: '建议检查网络连接状态，尝试刷新页面或切换网络环境。虫虫漫画持续优化服务器性能，确保读者获得流畅的阅读体验。如仍有问题欢迎通过联系渠道反馈。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于虫虫漫画，这里有你关心的一切答案</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              open={i === 0}
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer select-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200/60 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}